var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceBatteryLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 17.2,
    y1: 21.5,
    x2: 17.2,
    y2: 38.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.1,
    y1: 27.2,
    x2: 20.1,
    y2: 32.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 22.9,
    y1: 21.5,
    x2: 22.9,
    y2: 38.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.7,
    y1: 27.2,
    x2: 25.7,
    y2: 32.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 28.6,
    y1: 21.5,
    x2: 28.6,
    y2: 38.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.4,
    y1: 27.2,
    x2: 31.4,
    y2: 32.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 34.3,
    y1: 21.5,
    x2: 34.3,
    y2: 38.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 37.1,
    y1: 27.2,
    x2: 37.1,
    y2: 32.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 39.9,
    y1: 21.5,
    x2: 39.9,
    y2: 38.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.8,
    y1: 27.2,
    x2: 42.8,
    y2: 32.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8.7,29.5h2.2c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H8.7l0,2.3c1.6,0,2.8-1.3,2.8-2.8 c0-1.6-1.3-2.8-2.8-2.8S5.9,28.4,5.9,30c0,1.6,1.3,2.8,2.8,2.8v-0.7l0-1.7H6.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H8.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M50.8,30.5h-1.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0,0,0-1.7,0-1.7c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v1.7c0,0,1.7,0,1.7,0c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-1.7c0,0,0,1.7,0,1.7c0,0.3-0.2,0.5-0.5,0.5l0,0.2 c1.6,0,2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8l0-0.2l0,0c-0.3,0-0.5-0.2-0.5-0.5 C50.8,32.2,50.8,30.5,50.8,30.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceBatteryLight);
export default __webpack_public_path__ + "static/media/device-battery-light.d50e501f9baf26418910b034b5f62f26.svg";
export { ForwardRef as ReactComponent };